var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffice365Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7295 2.00318C17.8353 2.30859 18.5998 3.30342 18.5998 4.43687V19.5346C18.5998 20.6783 17.8191 21.6767 16.6989 21.9737L9.77344 23.9172L11.9995 19.1992V4.19866L10.1106 0.0675049L16.7295 2.00318Z",
    fill: "url(#paint0_linear_5476_27956)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 18.6011V20.9574C12.0004 23.2392 9.70596 24.7069 7.78889 23.6521L3.62714 20.985C3.14592 20.7054 2.88551 20.1077 3.04872 19.5107C3.20052 18.9551 3.72134 18.6011 4.26916 18.6011H12.0004Z",
    fill: "url(#paint1_linear_5476_27956)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36791 0.31637L1.21324 4.38812C0.463217 4.81534 0 5.61156 0 6.4744V17.5322C0 18.3464 0.875432 18.8613 1.58706 18.4646L4.27036 16.97C4.59737 16.7882 4.80018 16.4426 4.80018 16.0682V8.24686C4.80018 7.46263 5.26819 6.75881 5.97802 6.4774L12.0004 4.38572V2.53165C12.0004 0.609181 10.0018 -0.609464 8.36791 0.31637Z",
    fill: "url(#paint2_linear_5476_27956)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5476_27956",
    x1: 14.1866,
    y1: 1.70197,
    x2: 14.1866,
    y2: 21.9683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#E38400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#DB6200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#D44A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#D03B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#CF3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#D22900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D42400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5476_27956",
    x1: 3.55334,
    y1: 18.5717,
    x2: 12.6311,
    y2: 22.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F52537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#F32536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#EA2434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#DC2231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#C8202C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#AE1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#8F1A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5476_27956",
    x1: -1.57086,
    y1: 16.9748,
    x2: 10.7248,
    y2: -1.33129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D96AB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#D9538B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D91A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#D31A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C21926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A71821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#811619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#691515"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice365Icon);
export default __webpack_public_path__ + "static/media/Office365Icon.d5d9bdcd52b1ee8e02377aac3fecc4ec.svg";
export { ForwardRef as ReactComponent };